import axios from 'axios';
import {
    DELETE_USER,
    GET_USER,
    GET_USERS,
    POST_USER,
    UPDATE_USER,
    UPDATE_USER_PASSWORD
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_USERS, options);
    },
    async get(user, options = {}) {
        return await axios.get(GET_USER(user), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_USER, data, options);
    },
    async update(user, data, options = {}) {
        return await axios.patch(UPDATE_USER(user), data, options)
    },
    async delete(user, options = {}) {
        return await axios.delete(DELETE_USER(user), options);
    },
    async updatePassword(user, data, options = {}) {
        return await axios.patch(UPDATE_USER_PASSWORD(user), data, options)
    }
};
